import { Divider } from "@brexhq/metal-divider";
import { PaletteColor } from "@brexhq/metal-foundation";
import styled from "@emotion/styled";
import React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";
import { SanityDividerLineProps } from "@brexhq/shared/types/modules/BlockRowsModule/BlockRowItems";

interface Props extends Omit<SanityDividerLineProps, "_key" | "_type"> {
  color: PaletteColor;
}

const DividerContainer = styled(Container)<{
  isFullWidth: boolean;
}>((props) => {
  const { isFullWidth } = props;
  return {
    position: "relative",
    width: isFullWidth ? "100vw" : "100%",
  };
});

const getThickness = (thickness: "thin" | "regular" | "thick") => {
  switch (thickness) {
    case "thin":
      return 1;
    case "regular":
      return 2;
    case "thick":
      return 4;
    default:
      return 1;
  }
};

export const DividerLine = ({
  style,
  marginTop,
  color,
  thickness = "thin",
  isFullWidth,
}: Props) => (
  <DividerContainer
    isFullWidth={isFullWidth ?? false}
    margin={[marginTop, "none", "none"]}
  >
    <Divider
      color={color}
      borderStyle={style === "dotted" ? "dashed" : "solid"}
      width={getThickness(thickness)}
    />
  </DividerContainer>
);
